import React from 'react';

const Splash = () => {
    React.useEffect(() => {
        console.log('suspense fn');
    }, [])

    return (
        <div style={{
            height: '100%',
            width: '100%',
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column',
            userSelect: 'none'
        }}>
            Loading...
        </div >
    )
}

export default Splash;